module.exports = __webpack_public_path__ + "img/index_type_bg2.1c40974e.jpg";